import LogoDaee from '../../../../images/entities_logo/logo_daee.png'
import LogoIac from '../../../../images/entities_logo/logo_iac.png'
import LogoAna from '../../../../images/entities_logo/logo_ana.png'
import LogoFundag from '../../../../images/entities_logo/logo_fundag.png'
import LogoCemaden from '../../../../images/entities_logo/logo_cemaden.png'
import('./supporters.css')

export default function Supporters(options = {}){
    let main_container = options.container
    let attach_element = options.element
    let entities_show = options.entities_show || {daee:true, iac:false, ana:false, cemaden:false}
    let container, images_container
    this.generate = () =>{
        container = document.createElement("div")
        $(container).addClass("supporters-container")

        generateImages()
        container.appendChild(images_container)
        console.log(main_container);
        if(main_container){
            $(document.body).append(main_container)
        } else {
            $(document.body).append(container)
        }        

        setPosition()
    }

    this.generateToContainer = (target_container) =>{
        container = document.createElement("div")
        $(container).addClass("supporters-container-aux")

        generateImages()
        container.appendChild(images_container)
        
        $(target_container).append(container)
    }

    this.updatePosition = () =>{

    }

    function generateImages(){
        images_container = document.createElement('div')
        images_container.classList.add("supporters-images-container")

        // $.each([{url:LogoDaee,title:'daee'}, {url:LogoAna,title:'ana'} ,{url:LogoCemaden,title:'cemaden'}], (index, logo)=>{
        $.each(
            [{url:LogoDaee,title:'daee', show: entities_show.daee},
            {url:LogoIac,title:'iac', show: entities_show.iac},
            {url:LogoAna,title:'ana', show: entities_show.ana},
            {url:LogoCemaden,title:'cemaden', show: entities_show.cemaden},
            {url:LogoFundag,title:'fundag', show: entities_show.fundag}],
            (index, logo)=>{
                if(logo.show){
                    let image = generateImage(logo)
                    $(images_container).append(image.outerHTML)
                }
            
        })
    }

    function generateImage(logo){
        let image = document.createElement('div')
        image.classList.add("supporter-image-container")

        let img = new Image()
        img.src = logo.url
        if(logo.title == 'ana'){
            $(img).css({"height": "35px"})
        }
        $(image).append(img.outerHTML)
        return image

    }

    function setPosition(){
        $(container).css({"top": '50%', 'transform': 'translateY(-50%)'})
    }
}